const KEY = ['HOME'];

export { KEY };
